import type { CosmicVariationType } from '@/lib/cms/cosmic/types/CosmicProductType'

type Props = {
  variation: CosmicVariationType
  flavor: string
}

export const getIfVariationHasFlavor = ({ variation, flavor }: Props) => {
  const hasFlavor = variation.combinationName.split('/').includes(flavor)

  return hasFlavor || false
}
